export default "__VITE_ASSET__Dw$KUmT7__"